import React, { useContext } from "react";
import { Carousel, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
// import stage_l from "../../assets/stage_large.jpg";
// import stage_m from "../../assets/stage_medium.jpg";
// import stage_s from "../../assets/stage_small.jpg";
import { Chevron } from "../Icons/Chevron";
import {
  // AOS_ANIMATION,
  // AOS_DELAY,
  DIRECTUS_SERVER,
  STAGE_INTERVAL
} from "../../config";
import { StageContext } from "../../contexts/StageContext";
import { HTMLParser } from "../HTMLParser/HTMLParser";

export const Stage: React.FC = () => {
  const stageContext = useContext(StageContext);
  const stageItems = stageContext.stageItems;

  return (
    <div className="stage">
      <Carousel interval={STAGE_INTERVAL}>
        {/* <Carousel.Item>
          <div className="stage__item">
            <div className="stage__image">
              <img
                srcSet={`${stage_s} 320w, ${stage_m} 600w, ${stage_l} 900w`}
                src={stage_l}
                alt="Patient und Ärztin bedienen die App"
              />
            </div>
            <Col md={6}>
              <div className="stage__content stage__content--background">
                <h1 className="stage__headline">
                  Willkommen bei <strong className="no-break">Meine Uniklink</strong>
                </h1>
                <p
                  className="stage__text"
                  data-aos={AOS_ANIMATION}
                  data-aos-delay={1 * AOS_DELAY}
                >
                  Die wichtigsten Informationen für Sie als Patient*in des
                  Universitätsklinikums Freiburg in einer App.
                </p>
              </div>
            </Col>
          </div>
        </Carousel.Item> */}
        {stageItems.map(stageItem => {
          return (
            <Carousel.Item key={stageItem.id}>
              <div className="stage__item">
                <div className="stage__image">
                  <img
                    srcSet={`${DIRECTUS_SERVER +
                      stageItem.image.data
                        .asset_url}?w=900&h=600&q=80&f=crop 320w, ${DIRECTUS_SERVER +
                      stageItem.image.data
                        .asset_url}?w=1200&h=800&q=80&f=crop 600w, ${DIRECTUS_SERVER +
                      stageItem.image.data.asset_url} 900w`}
                    src={DIRECTUS_SERVER + stageItem.image.data.asset_url}
                    alt={stageItem.image.title}
                  />
                </div>
                <Col md={6}>
                  <div className="stage__content stage__content--background">
                    <h2 className="stage__headline">
                      <HTMLParser html={stageItem.headline_text} />
                    </h2>
                    {stageItem.description_text && (
                      <div className="stage__text">
                        <HTMLParser html={stageItem.description_text} />
                      </div>
                    )}
                    {stageItem.linked_article && (
                      <Link
                        className="stage__link stage__link--chevron"
                        to={`/article/${stageItem.linked_article.id}`}
                      >
                        <Chevron /> Mehr erfahren
                      </Link>
                    )}
                  </div>
                </Col>
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
};
